import React, { useEffect, useState } from 'react';
import Typography from '../../../layouts/theme-onboarding/Typography';
import Grid from '@mui/material/Grid';
import Color from '../../../layouts/Color';
import { Divider } from '@mui/material';

const ListCardItem = [
  {
    name: 'VISA Prepaid Standard',
    code: 'PV001',
    image: '/assets/images/product/standard.png',
    overview: 'Unlimited withdrawals',
    benifits: [
      'Free card issuance',
      'Free early payment',
      'Unlimited withdrawals'
    ],
    annualFees: {
      mainCard: '0',
      otherCard: '100.000'
    },
    description: 'The annual fee is refundable under the annual fee refund scheme if the customer makes a transaction within 90 days from the date the annual fee is debited to the Customers Credit Card account.'
  },
  {
    name: 'Virtual VISA Prepaid Standard',
    code: 'PV002',
    image: '/assets/images/product/platinum.png',
    overview: 'Unlimited bonus points',
    benifits: [
      'Accumulate and cashback 0.5% on domestic spending (electronic)',
      'Accumulate and cashback 0.7% on other foreign spending',
      'Accumulate and cash back 3% when spending at OPENWAY VIETNAM'
    ],
    annualFees: {
      mainCard: '200.000',
      otherCard: '200.000'
    },
    description: 'Withdraw up to 100% of the limit.'
  },
  {
    name: 'VISA Credit Standard',
    code: '00104',
    image: '/assets/images/product/vip.png',
    overview: 'Enjoy the offer for VISA VIP',
    benifits: [
      'Accumulate and cashback 0.5% on domestic spending',
      'Accumulate and cash back 1% on other foreign spending',
      'Accumulate and cash back 3% when spending at OPENWAY VIETNAME'
    ],
    annualFees: {
      mainCard: '1.000.000',
      otherCard: 'FREE'
    },
    description: 'The annual fee is refundable under the annual fee refund scheme if the customer makes a transaction within 90 days from the date the annual fee is debited to the Customers Credit Card account.'
  },
  {
    name: 'VISA Credit Platium Account-NEW',
    code: '00106',
    image: '/assets/images/product/vip.png',
    overview: 'Enjoy the offer for VISA VIP',
    benifits: [
      'Accumulate and cashback 0.5% on domestic spending',
      'Accumulate and cash back 1% on other foreign spending',
      'Accumulate and cash back 3% when spending at OPENWAY VIETNAME'
    ],
    annualFees: {
      mainCard: '1.000.000',
      otherCard: 'FREE'
    },
    description: 'The annual fee is refundable under the annual fee refund scheme if the customer makes a transaction within 90 days from the date the annual fee is debited to the Customers Credit Card account.'
  }
]

const container = {
  display: 'flex',
  alignItems: 'center',
  mb: 6,
  mt: 3
}

const imgGrid = { paddingRight: '30px' }

const img = { width: '100%' }

const contentGrid = { textAlign: 'left' }

const text = { mb: '15px' }

const title = { color: Color.Main, fontWeight: '400', mb: '10px' }

const list = { marginBottom: '5px' }

const listUl = { margin: 0, paddingLeft: '20px' }

export default function ProductDescription(props) {

  const [product, setProduct] = useState('');

  useEffect(() => {
    if (props.selectedProduct !== undefined && props.selectedProduct !== '') {
      ListCardItem.forEach(element => {
        if (element.code === props.selectedProduct) {
          setProduct(element);
        }
      });
    }
  }, [props.selectedProduct]);

  return (
    <React.Fragment>
      <Grid
        container
        sx={container}
      >
        {
          product !== undefined && product !== '' ? (
            <React.Fragment>
              <Grid sx={imgGrid} item xs={4}>
                <img src={process.env.PUBLIC_URL + product.image} alt={product.name} style={img} />
              </Grid>
              <Grid sx={contentGrid} item xs={8}>
                <Typography variant="h4" sx={text}>{product.name}</Typography>
                <Typography variant="body3" sx={text}>{product.overview}</Typography>
                <Divider sx={text} />
                <Typography variant="h5" sx={title}>Main Benifits</Typography>
                <ul style={listUl}>
                  {product.benifits.map((p) => <li key={p} style={list}>{p}</li>)}
                </ul>
                <Typography variant="h5" sx={title}>Annual Fees</Typography>
                <ul style={listUl}>
                  {product?.annualFees?.mainCard !== undefined &&
                    (<li style={list}>Main Card: {product.annualFees?.mainCard} VNĐ</li>)
                  }
                  {product?.annualFees?.otherCard !== undefined &&
                    (<li style={list}>Other Card: {product.annualFees?.otherCard} VNĐ</li>)
                  }
                </ul>
                <Typography variant="body3">※ {product.description}</Typography>
              </Grid> </React.Fragment>) : (
            <React.Fragment>
              <Grid sx={imgGrid} item xs={4}>
                <img src={process.env.PUBLIC_URL + '/assets/images/product/vip.png'} alt={'None'} style={img} />
              </Grid>
              <Grid sx={contentGrid} item xs={8}>
                <Typography variant="h4" sx={text}>Product Name</Typography>
                <Typography variant="body3" sx={text}>Product Overview</Typography>
                <Divider sx={text} />
                <Typography variant="h5" sx={title}>Main Benifits</Typography>
                <ul style={listUl}>
                </ul>
                <Typography variant="h5" sx={title}>Annual Fees</Typography>
                <ul style={listUl}>
                </ul>
                <Typography variant="body3">※ </Typography>
              </Grid> </React.Fragment>
          )
        }
      </Grid>
    </React.Fragment>
  );
}
